var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { position: "relative" } }, [
    _c("div", { staticClass: "custom-notification create" }, [
      _c(
        "div",
        {
          staticClass: "custom-notification__content",
          class: {
            "has-overflow": _vm.overflow,
            "is-full-width": !_vm.sidebar,
          },
        },
        [_vm._t("content")],
        2
      ),
      _vm._v(" "),
      _vm.sidebar
        ? _c(
            "div",
            { staticClass: "custom-notification__sidebar" },
            [_vm._t("sidebar")],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "custom-notification__cta",
        class: {
          "has-overflow": _vm.overflow,
        },
      },
      [
        _vm._t("cta", function () {
          return [
            _vm.lastPage
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                      click: _vm.lastPage,
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-chevron-left" }),
                    _vm._v(" Previous\n      "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                  click: _vm.nextPage,
                },
              },
              [
                _vm._v("\n        Continue "),
                _c("i", { staticClass: "fa fa-chevron-right" }),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }